export const stripMarkdown = (text: string): string =>
  text
    // links: [label](url) → label
    .replace(/\[([\s\S]+?)\]\([\s\S]+?\)/g, '$1')
    // bold/italic: ***x***, **x**, *x*, __x__, _x_
    .replace(/\*{1,3}([\s\S]+?)\*{1,3}/g, '$1')
    .replace(/_{1,2}([^_]+?)_{1,2}/g, '$1')
    // headings: ## Title → Title
    .replace(/^#{1,6}\s+/gm, '')
    // table separator rows: |---|---| or |:---|:---:|
    .replace(/^\|[\s|:-]+\|\s*$/gm, '')
    // table rows: strip leading/trailing pipes and collapse cell separators
    .replace(/^\|(.+)\|$/gm, (_, inner: string) =>
      inner
        .split('|')
        .map(cell => cell.trim())
        .filter(Boolean)
        .join(' ')
    )
    // code fences
    .replace(/^```[\s\S]*?```/gm, '')
    // horizontal rules
    .replace(/^[-*_]{3,}\s*$/gm, '')
    // bullet / numbered list markers at line start
    .replace(/^[\s]*[-*+]\s+/gm, '')
    .replace(/^[\s]*\d+\.\s+/gm, '')
    .trim();

/** Returns only the first non-empty line after stripping markdown. */
export const firstMarkdownLine = (text: string): string =>
  stripMarkdown(text)
    .split('\n')
    .map(l => l.trim())
    .find(l => l.length > 0) ?? '';
